/**
 * @file     NavRailIcon.tsx
 * @readme   ./README.md
 * @purpose  Line icons for the header rail and mobile sheet, one per navigation category.
 */
import type { NavigationCategory } from '@/core/constants/navigation';

const PATHS: Record<NavigationCategory['key'], string> = {
  buy: 'M3 11l9-7 9 7M5 10v10h14V10',
  rent: 'M10.8 12.2 20 3M17 6l2.5 2.5M14.5 8.5 17 11M11 15a4 4 0 1 1-8 0 4 4 0 0 1 8 0z',
  sell: 'M4 20V10l8-6 8 6v10M9 20v-5h6v5',
  data: 'M4 19h16M6 15l4-4 3 3 5-6',
  tools: 'M6 3h12v18H6zM9 7h6M9 11h1M12 11h1M15 11h1M9 15h1M12 15h1M15 15h1',
  learn: 'M3 7l9-4 9 4-9 4-9-4zM7 9v5c0 1.5 2.2 3 5 3s5-1.5 5-3V9',
  blog: 'M5 4h14v16H5zM8 8h8M8 12h8M8 16h5',
  about: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21c0-3.3 3.6-6 8-6s8 2.7 8 6',
};

export const NavRailIcon = ({ categoryKey, size = 18 }: { categoryKey: NavigationCategory['key']; size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d={PATHS[categoryKey]} />
  </svg>
);
